import * as React from 'react';
import { cva } from 'class-variance-authority';

import { cn } from '@/lib/utils';
import Breadcrumbs from '@/components/custom/breadcrumbs/breadcrumbs';

const appName = process.env.REACT_APP_NAME;
const hasCustomLogos = appName === 'canaleducacao' || appName === 'maiseducacao';

const dashboardContentVariants = cva('ml-0 !px-4 pb-4 pt-[110px] w-full max-w-screen overflow-x-hidden overflow-y-auto bg-neutral-bright bp-md:pt-[104px] bp-md:!px-11 bp-md:pb-11', {
  variants: {
    variant: {
      default: 'flex flex-col justify-start flex-wrap',
      plain: ''
    },
    minHeight: {
      default: 'min-h-screen', // 100vh
      minusHeader: 'min-h-[calc(100vh-68px)] bp-md:min-h-screen' // 100vh - 68px
    },
    viewMode: {
      default: 'bp-md:ml-16 bp-md:w-[calc(100%-64px)]',
      create: 'bp-md:ml-[260px] bp-md:w-[calc(100%-260px)]'
    }
  },
  defaultVariants: {
    variant: 'default',
    minHeight: 'default',
    viewMode: 'default'
  }
});

const DashboardContent = React.forwardRef(({ className, variant, viewMode, breadcrumbs, breadcrumbsVerified, breadcrumbsActions, children, ...props }, ref) => {
  const minHeightVariant = hasCustomLogos ? 'minusHeader' : 'default';

  return (
    <div
      ref={ref}
      className={cn('c-dashboard-content', dashboardContentVariants({ variant, viewMode, minHeight: minHeightVariant }), className)}
      {...props}
    >
      {breadcrumbs && (
        <Breadcrumbs
          data={breadcrumbs}
          innerContent={breadcrumbsVerified}
          actions={breadcrumbsActions}
        />
      )}

      {children}
    </div>
  );
});
DashboardContent.displayName = 'DashboardContent';

const Dashboard = React.forwardRef(({ className, ...props }, ref) => (
  <div
    ref={ref}
    className={cn('c-dashboard', 'relative flex min-h-screen w-full flex-wrap items-start justify-between', className)}
    {...props}
  />
));
Dashboard.displayName = 'Dashboard';

export { DashboardContent, Dashboard };
